export default __webpack_public_path__ + "static/media/Trustpilot-Logo.cd37f3ec.png";